const createISODateWithGermanTimezone = (date) => {
  let new_date_object = new Date(date)
  // getMonth returns 0 for January -> Add 1 for ease of use
  const dates_month = new_date_object.getMonth() + 1
  const summertime = dates_month >= 4 && dates_month < 11
  new_date_object.setTime(
    new_date_object.getTime() + (summertime ? 2 : 1) * 60 * 60 * 1000
  )
  const new_date_string = new_date_object
    .toISOString()
    .split(".")[0]
    .concat(summertime ? "+02:00" : "+01:00")

  return new_date_string
}

module.exports = createISODateWithGermanTimezone
